<template>
    <tg-layout>
        <template slot="header">
            <template v-if="isHistory">
                <tg-search-tool @on-submit="handleSearch">
                    <tg-date-picker
                        v-model="searchData.openDate"
                    ></tg-date-picker>
                    <el-input
                        :placeholder="$t('column.game_name')"
                        v-model="searchData.gameName"
                        class="tg-input"
                        size="small"
                        style="width: 240px"
                        clearable
                        @input="inputLimit"
                    ></el-input>
                </tg-search-tool>
            </template>
            <template v-else>
                <tg-button
                    round
                    border
                    hoverBorderOnly
                    theme="primary"
                    :active-gradient="isToday"
                    @click.native="toggleDate(today)"
                    >{{ $t("component.date.picker.today")
                    }}{{ today }}</tg-button
                >
                <tg-button
                    round
                    border
                    hoverBorderOnly
                    theme="primary"
                    :active-gradient="!isToday"
                    @click.native="toggleDate(tomorrow, false)"
                    >{{ $t("component.date.picker.tomorrow")
                    }}{{ tomorrow }}</tg-button
                >
            </template>
        </template>
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            showPagination
        >
            <template slot="game_name" slot-scope="scope">
                <span
                    >{{ scope.row["gameTime"] }} [{{
                        scope.row["competition"]
                    }}]</span
                ><br />
                <span
                    ><i class="tg-icon tg-icon-grayball"></i
                    >{{ scope.row["team1"] }}</span
                ><br />
                <span
                    ><i class="tg-icon tg-icon-grayball"></i
                    >{{ scope.row["team2"] }}</span
                ><br />
            </template>

            <template slot="betCell" slot-scope="scope">
                <span
                    :class="{ 'as-link': scope.value != '0/0' }"
                    @click="
                        scope.value != '0/0'
                            ? showBet(scope.column, scope.row)
                            : null
                    "
                    >{{ scope.value }}</span
                >
            </template>
        </tg-table>
    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDatePicker from "@/components/datePicker/TgDatePicker";
import TgButton from "@/components/button/TgButton";

import date from "@/utils/date";
import apis from "@/apis";
const api = apis.game.invest;

export default {
    components: {
        TgLayout,
        TgTable,
        TgSearchTool,
        TgDatePicker,
        TgButton,
    },
    data() {
        return {
            columns: [],
            proxy: api.getData,
            searchData: {
                openDate: null,
                gameName: "",
            },
            isToday: true,
        };
    },
    props: {
        isHistory: Boolean,
    },
    computed: {
        request() {
            return {
                type: this.isHistory ? 2 : 1,
                ...this.searchData,
            };
        },
        today() {
            return date.today();
        },
        tomorrow() {
            return date.tomorrow();
        },
    },
    created() {
        this.$store.commit("breadcrumb/clear");
        this.searchData.openDate = this.today;

        api.getColumns().then((response) => {
            this.columns = response.data;
            this.$nextTick(() => {
                this.$refs.table.init(this.request);
            });
        });
    },
    methods: {
        showBet(column, row) {
            let routeName = this.isHistory
                ? "game.history-detail"
                : "game.invest-detail";
            this.$router.push({
                name: routeName,
                params: {
                    row: row,
                    column: column,
                    isHistory: this.isHistory,
                },
                title: row.name,
            });
        },
        toggleDate(date, isToday = true) {
            this.isToday = isToday;
            this.searchData.openDate = date;

            this.$nextTick(() => {
                this.$refs.table.search(this.request);
            });
        },
        handleSearch() {
            this.$refs.table.search(this.request);
            
        },
        inputLimit(val) {
            // 正则匹配非中英文及数字的字符
            let reg = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            // 查找是否有非中英文及数字的字符
            // 没有则返回-1，有则返回对应位置
            let n = val.search(reg);
            if ( n !== -1 ) {
                // 由于每次触发，通常只有最后一个字符是有可能异常的
                // 所以这里是直接截取异常字符前面的部分
                this.searchData.gameName = val.slice(0, n);
            }
        }
    },
    watch: {
        isHistory(val) {
            if (!val) {
                this.isToday = true;
                this.searchData.gameName = "";
            }
            this.$nextTick(() => {
                this.handleSearch();
            });
        },
    },
};
</script>